import { render } from "./UpdateDnsServer.vue?vue&type=template&id=d1ca8a8e&scoped=true"
import script from "./UpdateDnsServer.vue?vue&type=script&lang=js"
export * from "./UpdateDnsServer.vue?vue&type=script&lang=js"

import "./UpdateDnsServer.vue?vue&type=style&index=0&id=d1ca8a8e&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ca8a8e"]])

export default __exports__